import * as React from "react";
import {Icon} from "./Icon";

export class DocumentsIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <rect x="14" y="14" width="8" height="2" />
            <rect x="14" y="20" width="18" height="2" />
            <rect x="14" y="32" width="16" height="2" />
            <rect x="14" y="26" width="18" height="2" />
            <path d="M32,4H8V44H40V12Zm0,2.83L37.17,12H32ZM38,42H10V6H30v8h8Z" />
      </svg>
    </Icon>;
  }
}
